<template>
  <b-row class="w-100 flex mt-3" flex>
    <b-col md="6" lg="4">
      <b-form-file v-model="image"
                   accept="image/jpeg, image/jpg, image/png, image/gif"
                   :alt="altText || 'Produkt bild'"
                   class="mr-3 w-100" browse-text="Durchsuchen"
                   placeholder="Keine Datei ausgewählt">

      </b-form-file>
    </b-col>
    <b-col md="6" lg="4">
      <b-button @click="upload" :disabled="inProgress || !image" class="w-100">Hochladen</b-button>
    </b-col>
  </b-row>
</template>

<script>
import products from "@/api/products";

export default {
  props: ['productId', 'productName', 'altText'],
  data(){
    return {
      image: null,
      alt: '',
      filename: '',
      inProgress: false
    }
  },
  computed: {
    dataComplete() {
      return (this.image !== null) && (this.alt !== '')
    }
  },
  methods: {
    upload() {
      this.inProgress = true;
      products.addImage(this.productId, this.image, this.image.name, this.altText || this.alt).then(
          () => this.$emit('image-uploaded')
      ).catch(
          () => this.$bvModal.show('error-modal')
      ).finally(
          () => {
            this.inProgress = false
            this.image = null
          }
      )
    }
  }
}
</script>
